window.addEventListener('DOMContentLoaded', () => {
  // password reset, change title and breadcrumb
  const recoverButton = document.getElementById("RecoverPassword");
  const hideRecoverButton = document.getElementById("HideRecoverPasswordLink");
  const title  = document.querySelector("h1");
  const breadcrumbActive = document.getElementById("loginBread");
  recoverButton.addEventListener('click', () => {
    title.innerText = `パスワードリセット`;
    breadcrumbActive.innerHTML = `
      <span class="breadcrumb__divider" aria-hidden="true">
        <svg width="6" height="10" viewBox="0 0 6 10">
          <path d="M2,1,3,0,7,4,8,5,7,6,3,10,2,9,6,5" transform="translate(-2)" fill="#454545"/>
        </svg>
      </span>
      <a href="${theme.routes.login}" title="accounts-login">
        <span>ログイン</span>
      </a>
      <span class="breadcrumb__divider" aria-hidden="true">
        <svg width="6" height="10" viewBox="0 0 6 10">
          <path d="M2,1,3,0,7,4,8,5,7,6,3,10,2,9,6,5" transform="translate(-2)" fill="#454545"/>
        </svg>
      </span>
      <span class="active">パスワードリセット</span>
    `;
  })
  hideRecoverButton.addEventListener('click', () => {
    title.innerText = `ログイン`;
    breadcrumbActive.innerHTML = `
      <span class="breadcrumb__divider" aria-hidden="true">
        <svg width="6" height="10" viewBox="0 0 6 10">
          <path d="M2,1,3,0,7,4,8,5,7,6,3,10,2,9,6,5" transform="translate(-2)" fill="#454545"/>
        </svg>
      </span>
      <span class="active">ログイン</span>
    `;
  })
  // end password reset, change title and breadcrumb

  // if return url cart, change DOM
  const url = new URL(window.location.href);
  const return_parms = url.searchParams.get('return_url');
  if (return_parms === "/cart?page=receive") {
    const breadSpan = document.createElement("span");
    breadSpan.innerHTML = `
      <span class="breadcrumb__divider" aria-hidden="true">
        <svg width="6" height="10" viewBox="0 0 6 10">
          <path d="M2,1,3,0,7,4,8,5,7,6,3,10,2,9,6,5" transform="translate(-2)" fill="#454545"></path>
        </svg>
      </span>
      <a href="${theme.routes.cartPage}">ショッピングバッグ</a>
    `;
    breadcrumbActive.before(breadSpan);
    const pageWidth = document.querySelector(".page-width.page-login");
    pageWidth.classList.add("page-width--wide");
    const loginContainer = document.getElementById("CustomerLoginFormContainer");
    loginContainer.classList.add("cart-layout");
    const nomemberSection = document.createElement("div");
    nomemberSection.setAttribute("id", "CustomerContinueSection");
    nomemberSection.innerHTML = `
      <h2>会員登録がお済みでないお客様</h2>
      <p class="font-gothic high-margin-bottom align-left">会員登録しないで購入を希望する方はこちらからご利用ください。<br />
必要に応じて、ご注文の後に会員登録していただくこともできます。<br></p>
      <div class="align-center">
      <a href="${theme.routes.register}?return_url=/cart?page=receive" class="btn btn--full">会員登録はこちら</a>
      <a href="${theme.routes.cartPage}?page=receive" class="btn btn--full btn--secondary">会員登録しないで購入する</a>
      </div
    `;
    loginContainer.appendChild(nomemberSection);
    const loginForm = document.getElementById("CustomerLoginForm");
    const loginFormHeader = document.createElement("div");
    loginFormHeader.innerHTML = `
      <h2>既に会員登録がお済みのお客様</h2>
      <p class="font-gothic align-left high-margin-bottom">メールアドレスとパスワードを入力して下さい。</p>
    `;
    loginForm.prepend(loginFormHeader);
    loginForm.querySelector("p.btn--secondary").remove();
  }

  //CUSTOMER LOGIN VALIDATION NULL CHECK
  const loginCustomerButton = document.getElementById('login-submit');
  if (loginCustomerButton) {
    loginCustomerButton.addEventListener('click', (event) => {
      let nullFlag = false;
      const requireInputs = document.querySelectorAll("input.require");

      // HIDE REQUIRE ERROR * FIRST TIME
      const errorVisible = document.querySelectorAll(".require-error");
      for (const text of errorVisible) {
        text.style.visibility = "hidden";
      }
      // CHECK IF INPUT NULL
      for (const input of requireInputs) {
        if (!input.value) {
          // console.log("input value is null");
          nullFlag = true;
          const label = input.previousElementSibling;
          label.querySelector(".require-error").style.visibility = "visible";
        }
      }
      if (nullFlag) {
        event.preventDefault();
      }
    })
  }
})